import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";
import { flatteResourceExplorerHierarchyData } from "../../selectors/views-hierarchy/utils/flatteResourceExplorerHierarchyData";
import { setNavigationResourceExplorer } from "../../../navigation/navigationSlice";
import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const getResourceExplorerViewsHierarchyThunk = createAsyncThunk(
  "resourceExplorer/getResourceExplorerViewsHierarchy",
  async (_, { dispatch }) => {
    const { getUsersMeOrganisationsCurrentResourceExplorerViewsHierarchy } =
      cloudChiprApi.endpoints;

    try {
      const response = await dispatch(
        getUsersMeOrganisationsCurrentResourceExplorerViewsHierarchy.initiate(
          {},
          { forceRefetch: true },
        ),
      ).unwrap();

      if (response) {
        dispatch(
          setNavigationResourceExplorer(
            flatteResourceExplorerHierarchyData(response),
          ),
        );
      }
    } catch (e) {
      // @ts-expect-error TODO: return to this after adding error type
      const errMessage = e?.data?.message || "Something went wrong";
      enqueueSnackbar(errMessage, {
        variant: "snackbarAlert",
        AlertSnackBarProps: {
          severity: "error",
        },
      });
    }
  },
);
